﻿module.exports = {
    bindings: {
        measure: '<'
    },
    templateUrl: 'additional-codes/components/measure-additional-codes-expanded.html'
};